import { createRouter, createWebHashHistory/* createWebHistory  */} from 'vue-router'
import useFunctions from '@/composables/useFunctions'

import campusRouter from '../modules/sievi/router/campus'
import typeHfsRouter from '../modules/sievi/router/typeHfs'
import homeRouter from '../modules/sievi/router/home'
import errorRouter from '../modules/sievi/router/error'
import periodRouter from '../modules/sievi/router/period'
import hfsRouter from '../modules/sievi/router/hfs'
import programRouter from '../modules/sievi/router/program'
import userRouter from '../modules/sievi/router/user'
import authRouter from '../modules/auth/router'
import isAuthenticatedGuard from '../modules/auth/router/auth-guard'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: { name: 'auth.login' }
  },
  {
    path: '/auth',
    beforeEnter: [ isAuthenticatedGuard ],
    ...authRouter
  },
  {
    path: '/campus',
    beforeEnter: [ isAuthenticatedGuard ],
    ...campusRouter
  },
  {
    path: '/tipo-hfs',
    beforeEnter: [ isAuthenticatedGuard ],
    ...typeHfsRouter
  },
  {
    path: '/hfs',
    beforeEnter: [ isAuthenticatedGuard ],
    ...hfsRouter
  },
  {
    path: '/programa',
    beforeEnter: [ isAuthenticatedGuard ],
    ...programRouter
  },
  {
    path: '/home',
    beforeEnter: [ isAuthenticatedGuard ],
    ...homeRouter
  },
  {
    path: '/periodo',
    beforeEnter: [ isAuthenticatedGuard ],
    ...periodRouter
  },
  {
    path: '/usuarios',
    beforeEnter: [ isAuthenticatedGuard ],
    ...userRouter
  },
  {
    path: '/error',
    beforeEnter: [ isAuthenticatedGuard ],
    ...errorRouter
  },
  {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      redirect: { name: 'sievi.error' },
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  // history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  const { toCamelCase } = useFunctions()
  document.title = `${ process.env.VUE_APP_TITLE } -  ${ toCamelCase(to.path.split('/').filter(item => item !== '')[0]) }`
})

export default router
